import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "export-progress-loader" }
const _hoisted_2 = { class: "export-progress-loader__header" }
const _hoisted_3 = { class: "export-progress-loader__header-status" }
const _hoisted_4 = { class: "export-progress-loader__inner" }

import ExportDetail from '@/components/export/ExportDetail.vue'
import ProgressBar from '@/components/export/ProgressBar.vue'
import { useExportStore } from '@/store/export-store'
import { useProjectStore } from '@/store/project-store'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportProgressLoader',
  setup(__props) {

const projectStore = useProjectStore()
const exportStore = useExportStore()

const completedPercentageFormatted = computed(() => {
  const progressPercentageLimited = progressPercentage.value > 99 ? 99 : progressPercentage.value
  return progressPercentageLimited.toFixed(0) + '%'
})

const status = computed(() => progressPercentage.value < 99 ? 'Rendering your video' : 'Finalizing your video')

const duration = computed(() => new Date(exportStore.durationMilliseconds).toISOString().slice(14, 19))
const orientation = computed(() => {
  switch (projectStore.orientation) {
  case 'portrait': {
    return 'Portrait 9:16'
  }
  case 'landscape': {
    return 'Landscape 16:9'
  }
  case 'square': {
    return 'Square 1:1'
  }
  default: {
    return ''
  }
  }
})
const format = computed(() => exportStore.fileFormat.toUpperCase())
const progressPercentage = computed(() => {
  const percentage = (exportStore.elapsedMilliseconds/(exportStore.durationMilliseconds)) * 100
  if (percentage < 0 || percentage > 100) {
    return percentage < 0 ? 0 : 100
  }
  return percentage
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(status)), 1),
      _createTextVNode(" - stay on this tab for best performance.")
    ]),
    _createVNode(ProgressBar, {
      class: "export-progress-loader__progress-bar",
      completedPercentage: _unref(progressPercentage)
    }, null, 8, ["completedPercentage"]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(ExportDetail, {
        class: "export-progress-loader__video-duration",
        label: "Video duration: ",
        value: _unref(duration)
      }, null, 8, ["value"]),
      _createVNode(ExportDetail, {
        class: "export-progress-loader__aspect-ratio",
        label: "Aspect ratio: ",
        value: _unref(orientation)
      }, null, 8, ["value"]),
      _createVNode(ExportDetail, {
        label: "File format: ",
        value: _unref(format)
      }, null, 8, ["value"]),
      _createVNode(ExportDetail, {
        class: "export-progress-loader__completed-percentage",
        label: "",
        value: _unref(completedPercentageFormatted),
        "is-value-large-size": true
      }, null, 8, ["value"])
    ])
  ]))
}
}

})